import { Navigate, Outlet } from 'react-router-dom'
import { RemoveScrollBar } from 'react-remove-scroll-bar'
import { useAuth } from '../../hooks/useAuth'
import { ReactElement } from 'react'

export const HomeLayout = (): ReactElement => {
  const { user, userProfile } = useAuth()

  if (user !== null && user !== undefined && userProfile != null && userProfile !== undefined) {
    if (userProfile.role.slug === 'admin') {
      return <Navigate to='/dashboard/all-assigned-students' />
    } else {
      return <Navigate to='/user-dashboard' />
    }
  }

  return (
    <>
      <RemoveScrollBar />
      <Outlet />
    </>
  )
}
